import React from "react";

import type { DesignGuideCardBlock } from "@reactivated";

import { DesignGuideDownloadForm } from "../CRMForm/DesignGuideDownload";
import { CenteredModal } from "../CenteredModal";
import { ButtonPrimary } from "../Clickables";
import { RichTextStreamBlock, firstHeadingId } from "../RichTextStreamBlock";

import styles from "./DesignGuideModalTrigger.module.scss";

/** The design-guide download button and its gated form modal, rendered in the
 * landing card's CTA slot. */
export const DesignGuideModalTrigger = ({
    value,
}: {
    value: DesignGuideCardBlock;
}) => {
    if (!value.download_cta) return <></>;

    return (
        <CenteredModal
            trigger={<ButtonPrimary>{value.download_cta}</ButtonPrimary>}
            theme="black"
            panelClassName={styles.panel}
            labelledBy={firstHeadingId(value.form_heading ?? null)}
            label={value.download_cta ?? undefined}
        >
            <RichTextStreamBlock value={value.form_heading ?? null} />
            <DesignGuideDownloadForm
                layout="complementary"
                documentLink={value.design_guide ?? null}
                successContent={value.success_content ?? null}
                custom_submit_url={null}
            />
        </CenteredModal>
    );
};
